<script>
// Muestra un PDF dentro de la app. Recibe una URL firmada de S3 que ya viene
// con Content-Disposition inline, así que el navegador lo renderiza con su
// visor nativo (que además tiene imprimir y zoom).
export default {
  name: "ModalPdfViewer",

  props: {
    visible: { type: Boolean, required: true },
    url: { type: String, default: null },
    title: { type: String, default: "Informe" },
  },

  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<template lang="pug">
  el-dialog.modal-pdf-viewer(
    :visible="visible"
    :before-close="close"
    :title="title"
    width="90%"
    top="4vh"
    append-to-body
  )
    iframe.pdf-frame(v-if="visible && url" :src="url" :title="title")
</template>

<style lang="scss" scoped>
.pdf-frame {
  width: 100%;
  height: 80vh;
  border: none;
}
</style>
